<div class="container">
  <img srcset="
    /assets/knight-frank-white.png 1x,
    /assets/knight-frank-white@2x.png 2x,
    /assets/knight-frank-white@3x.png 3x
    " alt="Knight Frank" class="logo logo-kf">

  <main role="main">
    <section>
      <div class="auth-box-parent">
        <div class="auth-box">
          <img srcset="
            /assets/vision-insights.png 1x,
            /assets/vision-insights@2x.png 2x,
            /assets/vision-insights@3x.png 3x
            " alt="Vision Insights" class="logo logo-vs">

          <ng-container *ngIf="isLocalhost">
            <button type="button" class="w-100 btn btn-lg login-btn" (click)="login()">
              <ng-container *ngIf="!isLoggingIn">
                Log in
              </ng-container>
              <ng-container *ngIf="isLoggingIn">
                Redirecting...
              </ng-container>
            </button>
          </ng-container>

          <ng-container *ngIf="!isLocalhost">
            <div id="captcha-container"></div>

            <button type="button" class="w-100 btn btn-lg login-btn" (click)="triggerCaptcha()">
              <ng-container *ngIf="!isLoggingIn">
                Log in
              </ng-container>
              <ng-container *ngIf="isLoggingIn">
                Redirecting...
              </ng-container>
            </button>
          </ng-container>
        </div>
      </div>
    </section>
  </main>
</div>

<footer class="footer pl-3">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        &copy; Knight Frank Australia {{ year }}
      </div>
      <div class="col-md-6 text-end">
        <a href="/privacy" target="_blank">privacy policy</a>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <a href="/support" target="_blank">help</a>
      </div>
    </div>
  </div>
</footer>
